import template from './diagramComplete.partial.html';

export default () => {

    return {
        scope: {
          completeTitle: '<',
          nextTitle: '<'
        },
        restrict: 'E',
        replace: true,
        transclude: true,
        template
    };

};



// WEBPACK FOOTER //
// ./client/app/blocks/diagramComplete/diagramComplete.directive.js